



























































import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import _ from 'lodash';
import { useRouter } from 'vivat';

import getCashflowCategories from '@/gql/cashflow/getCashflowCategories.gql';
import deleteCashflowCategory from '@/gql/cashflow/deleteCashflowCategory.gql';

import { PaginatorInfo } from '@/types/paginatorInfo';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonFormWithCashFlowCategoryEditor from '@/components/Setting/CommonFormWithCashFlowCategoryEditor.vue';

const CashflowCategories = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonFormWithCashFlowCategoryEditor,
  },
  setup() {
    const { route, router } = useRouter();

    const filterCashFlowCategoryDropdown = ['ชื่อบัญชี'];
    const filterCashFlowCategoryValues = ['name'];
    const selectedFilterCashFlowCategory = ref('name');

    const addCategoryModal = ref(null);
    const editCategoryId = ref(-1);

    const search = reactive({
      category: '',
      categorySearchInput: '',
      pendingCategorySearch: false,
    });

    const cashflowCategories: Ref<any> = ref([]);
    const cashflowCategoriesPaginatorInfo: Ref<PaginatorInfo> = ref({});
    const cashflowCategoriesPage = ref(1);
    const { result: getCashflowCategoriesResult, loading: cashflowCategoriesLoading } = useQuery(getCashflowCategories, computed(() => ({
      page: cashflowCategoriesPage.value,
      first: 100,
    })), () => ({ fetchPolicy: 'network-only' }));

    const cashflowCategoriesResult = useResult(getCashflowCategoriesResult, [], (data) => data.cashFlowCategories);
    watch(() => cashflowCategoriesResult.value, (newVal, oldVal) => {
      if (!cashflowCategoriesLoading.value && newVal !== oldVal) {
        if (search.pendingCategorySearch || cashflowCategoriesResult.value.paginatorInfo.currentPage === cashflowCategoriesPaginatorInfo.value.currentPage) {
          cashflowCategories.value = [];
          cashflowCategories.value = cashflowCategoriesResult.value.data;
          cashflowCategoriesPage.value = 1;
          search.pendingCategorySearch = false;
        } else cashflowCategories.value = [...cashflowCategories.value, ...cashflowCategoriesResult.value.data];
        cashflowCategoriesPaginatorInfo.value = cashflowCategoriesResult.value.paginatorInfo;
      }
    });

    const selectCategoryHandler = (id: any) => {
      if (!(route.value.params.id === id)) router.push({ name: 'SettingPaymentAccount', params: { id } });
      return false;
    };

    const deleteCashFlowCategoryModal = ref(null);
    const deleteCategoryMutation = useMutation(deleteCashflowCategory, {
      refetchQueries: ['getCashflowCategories'],
    });
    function deleteCategoryAction(itemId: number) {
      deleteCategoryMutation.mutate({
        id: itemId,
      });
    }

    return {
      filterCashFlowCategoryDropdown,
      filterCashFlowCategoryValues,
      selectedFilterCashFlowCategory,

      search,

      cashflowCategories,
      cashflowCategoriesPaginatorInfo,

      selectCategoryHandler,

      addCategoryModal,
      editCategoryId,

      deleteCashFlowCategoryModal,
      deleteCategoryAction,
    };
  },
});

export default CashflowCategories;
